module.exports = "<div class=\"gw-loading-msg\" ng-show=\"errorInline || display || error\" ng-class=\"{'gw-loading-msg__inline': inline}\">\n    <div class=\"gw-wrapper\" ng-style='position' ng-show=\"display\">\n      <span class=\"gw-imageDiv\">\n          <img src=\"../styles/images/common/ajax-loader.gif\"/>\n      </span>\n        <span class=\"gw-hpadded\">{{msg}}</span>\n    </div>\n    <div class=\"gw-wrapper\" ng-style='position' ng-show=\"error\">\n        <span class=\"gw-hpadded\">{{errorInline || errorMsg}}</span>\n    </div>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/loading/templates/loading-template.html
 ** module id = 561
 ** module chunks = 0
 **/